/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["полн.", "полд.", "утра", "дня", "веч.", "ночи"], ["полн.", "полд.", "утра", "дня", "вечера", "ночи"], ["полночь", "полдень", "утра", "дня", "вечера", "ночи"]], [["полн.", "полд.", "утро", "день", "веч.", "ночь"], u, ["полночь", "полдень", "утро", "день", "вечер", "ночь"]], ["00:00", "12:00", ["04:00", "12:00"], ["12:00", "18:00"], ["18:00", "22:00"], ["22:00", "04:00"]]];
